import { useTheme } from '@mui/material/styles';
import { GradientTypography } from '../gradients/GradientTypography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { GameAnnouncement, GameAnnouncementProps } from './GameAnnouncement';
import { GradientBorder } from '../gradients/GradientBorder';

type GameAnnouncementsProps = {
  announcements: GameAnnouncementProps[];
};

export function GameAnnouncements({
  announcements = [],
}: GameAnnouncementsProps) {
  const theme = useTheme();
  if (announcements.length === 0) return null;
  return (
    <Box sx={{ height: '220px' }}>
      <GradientTypography
        variant="h5"
        gradientColor="primary.vertical"
        sx={{ textTransform: 'uppercase', pb: 1, pl: 3 }}
      >
        Announcements
      </GradientTypography>
      <GradientBorder borderRadius="10px">
        <Stack
          direction={'column'}
          alignItems={'stretch'}
          pr={1} // Spacing between the end of each announcement and the scrollbar
          borderRadius={'10px'}
          sx={{
            overflowY: 'auto',
            maxHeight: '200px',
            background: theme.palette.background.elevation[4],
          }}
        >
          {announcements
            .sort(
              (announcementA, announcementB) =>
                (announcementB.date ? announcementB.date.getTime() : 0) -
                (announcementA.date ? announcementA.date.getTime() : 0),
            )
            .map((announcementData) => (
              <GameAnnouncement
                {...announcementData}
                key={`${announcementData.title}${(
                  announcementData.date || ''
                ).toString()}`}
              />
            ))}
        </Stack>
      </GradientBorder>
    </Box>
  );
}
